<template lang="pug">
  .information-capability(v-loading="loading")
    .div(v-for="category in categories" :key="category.category_id")

      title-bar Category—{{ category.category_name }}

      el-row(v-for="(capability, index) in category.capabilities" :key="index" :gutter="10")
        el-col(:span="3")
          span {{ $t('项目名称') }}
          el-input(v-model="capability.project_name")
        el-col(:span="3")
          span {{ $t('客户名称') }}
          el-input(v-model="capability.client_name")
        el-col(:span="3")
          span {{ $t('品牌') }}
          el-input(v-model="capability.brand_name")
        el-col(:span="3")
          span {{ $t('行业') }}
          el-select(v-model="capability.industry_id")
            el-option(
              v-for="item, index in industries"
              :key="index"
              :label="$t(item.industry_name)"
              :value="item.industry_id"
            )
        el-col(:span="3")
          span {{ $t('合作开始时间') }}
          el-date-picker(v-model="capability.working_together_since" type="year" style="width:100%" value-format="yyyy-MM-DD")
        el-col(:span="5")
          span Scope
          el-checkbox-group(v-model="capability.scopes")
            el-checkbox(
              v-for="item in category.children"
              :key="item.scope_id"
              :label="item.scope_id"
            ) {{ item.scope_name }}
          template(v-if="capability.category_id === 3")
            el-checkbox(
              :label="capability.category_id"
              :disabled="true"
              :checked="true"
            ) Adv./Digital Production
          template(v-if="capability.category_id === 5")
            el-checkbox(
              :label="capability.category_id"
              :disabled="true"
              :checked="true"
            ) IT
        el-col(
          :span="3"
          style="display: flex; flex-direction: column"
        )
          span {{ $t('参考案例') }}
          el-upload(
            :before-upload="onBeforeUpload"
            action="-"
            accept=".ppt, .pdf, .pptx, .key"
            :http-request="upload(capability)"
            :show-file-list="false"
          )
            el-button(type="primary") {{ $t('点击上传') }}
          span(style="font-size: 12px; color: #808080") ({{ $t('仅PPT/PDF') }})
          a.text-overflow(
            :href="capability.file_download_path"
            style="display: inline-block; width: 100px;"
            target="_blank"
          ) {{ capability.file_name }}
        el-col(:span="4")
          span {{ $t('案例简介') }}
          el-input(
            v-model="capability.introduction"
            type="textarea"
            :rows="5"
            :maxlength="500"
            :placeholder="$t('案例介绍不多于500字')"
          )
        el-col(:span="1" v-if="index !== 0")
          el-button(
            icon="el-icon-delete"
            circle
            @click="deleCapability(category.capabilities, index)"
          )
        el-col(:span="1" v-else)
          //- el-button(
          //-   icon="el-icon-delete"
          //-   circle
          //-   @click="deleCapability(category.capabilities, index)"
          //- )
      span.information-capability--new(@click="addCapabilityItem(category)") + {{ $t('新增') }}

    .information-capability__buttons
      footer-button(
        :confirmButton="$t('保存')"
        @confirm="handleConfirm"
        @cancel="handleCancel"
      )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import { flatten } from 'lodash'
import dayjs from 'dayjs'
import FooterButton from '@/components/FooterButton'

const createItem = category => ({
  client_name: '',
  brand_name: '',
  industry_id: null,
  category_id: category.category_id,
  working_together_since: '',
  show_case_path: '',
  file_name: '',
  file_download_path: '',
  introduction: '',
  scopes: []
})

export default {
  components: {
    TitleBar,
    FooterButton
  },
  data () {
    return {
      categories: [],
      industries: [],
      loading: false
    }
  },
  async mounted () {
    this.loading = true
    const res = await axios.get('/vendor/vendor/getVendorCategory', {
      params: { vendor_id: this.$store.getters.user.struct_group_id }
    })

    this.categories = res.map(item => {
      item.capabilities = [createItem(item)]
      return item
    })
    await this.fetchIndustries()
    await this.fetchSavedInfo()
    this.loading = false
  },
  methods: {
    async fetchSavedInfo () {
      const res = await axios.get('/vendor/vendor/getCapability')
      this.categories = this.categories.map((item, index) => {
        if (res[index].client.length !== 0) {
          item.capabilities = res[index].client.map(i => ({
            client_name: i.client_name,
            brand_name: i.brand_name,
            industry_id: i.industry_id,
            category_id: item.category_id,
            working_together_since: new Date(i.working_together_since),
            show_case_path: i.show_case_path,
            show_case_thumbnail_path: i.show_case_thumbnail_path,
            file_name: i.file_name,
            file_download_path: i.file_download_path,
            introduction: i.introduction,
            scopes: i.scope.map(i => i.scope_id),
            project_name: i.project_name
          }))
        }
        return item
      })
    },
    async fetchIndustries () {
      this.industries = await axios.get('/vendor/vendor/getIndustry')
    },
    addCapabilityItem (category) {
      category.capabilities.push(createItem(category))
    },
    deleCapability (capabilities, index) {
      capabilities.splice(index, 1)
    },
    handleCancel () {
      this.$router.push('/information/view/basic-info')
    },
    async handleConfirm () {
      this.loading = true
      try {
        await axios.post('/vendor/vendor/updateCapability', format4backend(this.getParams()))
        this.loading = false
        this.$message.success(this.$t('编辑成功'))
        const res = await axios.get('/vendor/vendor/getUserCompletedStatus')
        const user = this.$store.getters.user
        user.is_completed = res.is_completed
        this.$store.commit('common/setUser', user)
        this.$router.push('/information/view/basic-info')
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    getParams () {
      const capabilities = flatten(this.categories.map(item => item.capabilities.map(item => ({
        project_name: item.project_name,
        client_name: item.client_name,
        brand_name: item.brand_name,
        industry_id: item.industry_id,
        category_id: item.category_id,
        working_together_since: dayjs(item.working_together_since).format('YYYY'),
        show_case_path: item.show_case_path,
        show_case_thumbnail_path: item.show_case_thumbnail_path,
        introduction: item.introduction || ''
      }))))

      const scope = flatten(this.categories.map(item => item.capabilities.map(item => item.scopes.map(item => ({
        scope_id: item
      })))))

      if (capabilities.length === 0) {
        this.$message.error(this.$t('每个Category需要至少一条完整的客户案例信息'))
        throw new Error()
      }

      const capabiitiesList = flatten(this.categories.map(i => i.capabilities))

      if (capabiitiesList.some(i => i.category_id !== 3 && i.category_id !== 5 && i.scopes.length === 0)) {
        this.$message.error(this.$t('每个Category需要至少一条完整的客户案例信息'))
        throw new Error()
      }

      let result
      for (let i = 0; i < capabilities.length; i++) {
        for (let j in capabilities[i]) {
          if (capabilities[i][j] == null || capabilities[i][j] === '') {
            result = capabilities[i]
            break
          }
        }
      }

      if (result != null) {
        this.$message.error(this.$t('每个Category至少需要一条完整的客户案例信息'))
        throw new Error()
      }
      return {
        vendor_capability: capabilities,
        vendor_capability_scope: scope,
        is_completed: this.$store.getters.user.is_completed
      }
    },
    upload (capability) {
      return async (inst) => {
        this.loading = true
        const formData = new window.FormData()
        formData.append('file', inst.file)
        formData.append('file_type', 15)
        const res = await axios.post('/management/subfinal/saveFile', formData)
        this.loading = false
        capability.show_case_path = res.file_path
        capability.show_case_thumbnail_path = res.show_case_thumbnail_path
        capability.file_name = res.file_name
        capability.file_download_path = res.file_download_path
      }
    },
    onBeforeUpload (file) {
      const result = file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file.type === 'application/pdf'
      if (!result) {
        this.$message.error(this.$t('文件格式错误，请重新上传'))
      }
      return result
    }
  }
}
</script>

<style lang="stylus">
.information-capability
  .el-checkbox + .el-checkbox
    margin-left 0
  .el-checkbox-group
    display flex
    flex-direction column
  .el-row
    display flex

.information-capability--new
  display inline-block
  font-size 12px
  color $main
  margin 20px 0
  cursor pointer

.information-capability__buttons
  display flex
  justify-content center
</style>
